import { createReducer, on } from "@ngrx/store";
import { initialPrintState, PrintState } from "./print.state";
import { ClearPrintState, SetPrintInitialAssessmentState, SetPrintLearnerRecordTabState, SetPrintLoaderState, SetPrintQandAState, SetPrintScreenerState, SetPrintSelfAssessmentState, SetPrintSkillsCheckState, SetPrintWrittenAssignState } from "./print.action";

export const PrintReducer = createReducer(
  initialPrintState,

  on(SetPrintScreenerState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedScreener: action.hasLoadedScreener,
      printLoader: action.hasLoadedScreener 
        && ((state.hasLoadedInitialAssessment && state.hasLoadedQandA) || state.hasLoadedSelfAssessment)
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedSkillsCheck
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintInitialAssessmentState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedInitialAssessment: action.hasLoadedInitialAssessment,
      printLoader: action.hasLoadedInitialAssessment 
        && state.hasLoadedScreener 
        && state.hasLoadedQandA
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedSkillsCheck
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintSelfAssessmentState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedSelfAssessment: action.hasLoadedSelfAssessment,
      printLoader: action.hasLoadedSelfAssessment 
        && state.hasLoadedScreener 
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedSkillsCheck
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintQandAState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedQandA: action.hasLoadedQandA,
      printLoader: action.hasLoadedQandA 
        && state.hasLoadedScreener 
        && (state.hasLoadedInitialAssessment || state.hasLoadedSelfAssessment)
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedSkillsCheck
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintLearnerRecordTabState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedLearnerRecordTab: action.hasLoadedLearnerRecordTab,
      printLoader: action.hasLoadedLearnerRecordTab 
        && state.hasLoadedScreener 
        && ((state.hasLoadedInitialAssessment && state.hasLoadedQandA) || state.hasLoadedSelfAssessment)
        && state.hasLoadedSkillsCheck
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintSkillsCheckState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedSkillsCheck: action.hasLoadedSkillsCheck,
      printLoader: action.hasLoadedSkillsCheck 
        && state.hasLoadedScreener 
        && ((state.hasLoadedInitialAssessment && state.hasLoadedQandA) || state.hasLoadedSelfAssessment)
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedWrittenAssignment ? false : state.printLoader
    }
  }),
  on(SetPrintWrittenAssignState, (state, action): PrintState => {
    return {
      ...state,
      hasLoadedWrittenAssignment: action.hasLoadedWrittenAssignment,
      printLoader: action.hasLoadedWrittenAssignment 
        && state.hasLoadedScreener 
        && ((state.hasLoadedInitialAssessment && state.hasLoadedQandA) || state.hasLoadedSelfAssessment)
        && state.hasLoadedLearnerRecordTab
        && state.hasLoadedSkillsCheck ? false : state.printLoader
    }
  }),
  on(SetPrintLoaderState, (state, action): PrintState => {
    return {
      ...state,
      printLoader: action.loader
    }
  }),
  on(ClearPrintState, (_): PrintState => {
    return initialPrintState;
  }),
)